import { useEffect } from "react";
import { useLeaflet } from "react-leaflet";
import L from "leaflet";
import "leaflet-choropleth";
import PropTypes from "prop-types";

const style = {
  fillColor: "#F28F3B",
  weight: 2,
  opacity: 1,
  color: "white",
  dashArray: "2",
  fillOpacity: 0.7,
};

const Choropleth = (props) => {
  const { map } = useLeaflet();
  const { mapData, mapSteps } = props;

  useEffect(() => {
    L.choropleth(mapData, {
      valueProperty: "responden",
      scale: ["white", "#389BF6"],
      steps: mapSteps,
      mode: "q",
      style,
      onEachFeature: (feature, layer) => {
        layer.bindTooltip(
          `${feature.properties.provinsi} <br/> ${feature.properties.responden} responden`
        );
      },
    }).addTo(map);
  }, [mapData]);

  return null;
};

Choropleth.propTypes = {
  mapData: PropTypes.object.isRequired,
  mapSteps: PropTypes.number.isRequired,
};

export default Choropleth;
